module.exports = __webpack_public_path__ + "img/SwissTrust6.6226a410.png";